export const LEGAL_CONTENT = {
    privacy: {
        title: "Privacy Policy",
        overline: "Legal",
        updated: "Last updated: [date to be inserted]",
        intro: "This Privacy Policy describes how LookAura (\u201cwe\u201d, \u201cour\u201d, or \u201cthe Service\u201d) handles information in connection with the LookAura mobile application and this website. The final legal text will be inserted here before public launch; the structure below is ready to receive it.",
        sections: [
            {
                heading: "Information We Collect",
                body: "[To be completed] A description of the information collected when you use LookAura, including account details you provide, preference information, and photos you choose to upload for appearance analysis.",
            },
            {
                heading: "Photos & Appearance Analysis",
                body: "[To be completed] How uploaded photos are processed by our AI systems, how long they are retained, and the controls available to you for deleting them.",
            },
            {
                heading: "How We Use Information",
                body: "[To be completed] How we use collected information to provide appearance analysis, generate personalized style recommendations, and improve the Service.",
            },
            {
                heading: "Product Recommendations & Third-Party Retailers",
                body: "LookAura may recommend products offered by third-party online retailers. When you follow a product link, you leave LookAura and interact with that retailer under their own privacy policy. Some product links may be affiliate links; see our Affiliate Disclosure for details.",
            },
            {
                heading: "Data Sharing",
                body: "[To be completed] Whether and how information is shared with service providers, analytics partners, or retailers.",
            },
            {
                heading: "Your Rights & Choices",
                body: "[To be completed] Access, correction, deletion, and other rights available to you, and how to exercise them.",
            },
            {
                heading: "Contact",
                body: "Questions about this policy can be sent to hello@lookaura.app (placeholder address — to be replaced with the official contact).",
            },
        ],
    },
    terms: {
        title: "Terms of Service",
        overline: "Legal",
        updated: "Last updated: [date to be inserted]",
        intro: "These Terms of Service govern your use of the LookAura mobile application and website. The final legal text will be inserted here before public launch; the structure below is ready to receive it.",
        sections: [
            {
                heading: "The Service",
                body: "LookAura is an AI-powered appearance and fashion recommendation platform. It analyzes photos you upload and your stated preferences to provide personalized style suggestions and product recommendations.",
            },
            {
                heading: "Not Professional Advice",
                body: "Recommendations generated by LookAura are automated suggestions for informational and inspirational purposes only. They do not constitute professional styling, medical, or dermatological advice.",
            },
            {
                heading: "Accounts & Acceptable Use",
                body: "[To be completed] Eligibility, account responsibilities, and rules for acceptable use of the Service.",
            },
            {
                heading: "Third-Party Retailers & Affiliate Links",
                body: "Product recommendations may link to third-party online retailers. LookAura is not responsible for third-party products, pricing, availability, or fulfilment. Some product links may be affiliate links, meaning LookAura may earn a commission on qualifying purchases at no additional cost to you.",
            },
            {
                heading: "Intellectual Property",
                body: "[To be completed] Ownership of the Service, its content, and the LookAura brand.",
            },
            {
                heading: "Limitation of Liability",
                body: "[To be completed] Standard limitation of liability and warranty disclaimer language.",
            },
            {
                heading: "Changes to These Terms",
                body: "[To be completed] How changes to these terms will be communicated.",
            },
        ],
    },
    "affiliate-disclosure": {
        title: "Affiliate Disclosure",
        overline: "Legal",
        updated: "Last updated: [date to be inserted]",
        intro: "Transparency matters to us. This page explains how affiliate links may be used within LookAura.",
        sections: [
            {
                heading: "Affiliate Links",
                body: "Some product links within LookAura may be affiliate links. LookAura may earn a commission when you make a purchase through these links, at no additional cost to you.",
            },
            {
                heading: "How Recommendations Work",
                body: "LookAura connects personalized style recommendations with relevant products from participating online retailers. Recommendations are generated from your appearance analysis and preferences; the presence of an affiliate programme does not determine whether a product is recommended to you.",
            },
            {
                heading: "No Endorsement of Specific Retailers",
                body: "References to participating retailers describe a category of third-party sellers. Unless expressly stated, LookAura does not claim endorsement by, or an active partnership with, any specific retailer.",
            },
            {
                heading: "Your Price Is Unaffected",
                body: "Using an affiliate link never increases the price you pay. Any commission is paid by the retailer or affiliate network.",
            },
            {
                heading: "Questions",
                body: "If you have questions about this disclosure, contact us at hello@lookaura.app (placeholder address — to be replaced with the official contact).",
            },
        ],
    },
};
